import { useTheme } from '@mui/material'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import { PaymentSteps } from '../../../app/paymentSteps'
import MoovyLink from '../../../components/moovyLink'
import usePaymentStep from '../../../hooks/usePaymentStep'

const Failure = () => {
  const [_currentPaymentStep, setCurrentPaymentStep] = usePaymentStep()
  const theme = useTheme()

  return (
    <>
      <Typography variant="h2">
        <FormattedMessage id="page.webPayment.stepFinish.info.failure" />
      </Typography>

      <Box alignItems="left" justifyContent="left" margin={2} textAlign="left">
        <Alert severity="error">
          <AlertTitle>
            <FormattedMessage id="page.webPayment.stepFinish.failureInfo" />
          </AlertTitle>
          <List
            sx={{
              paddingLeft: 2,
              listStyleType: 'disc',
              ...theme.typography.body1,
            }}
          >
            {[1, 2, 3, 4, 5].map((n) => (
              <ListItem
                sx={{ display: 'list-item' }}
                key={`failure-info-list-item-${n}`}
              >
                <FormattedMessage
                  id={`page.webPayment.stepFinish.failureInfoList.item${n}`}
                />
              </ListItem>
            ))}
          </List>
          <Typography variant="body1">
            <FormattedMessage id="page.webPayment.stepFinish.failureInfoList.footer" />
          </Typography>
        </Alert>
      </Box>

      <MoovyLink.Link
        onClick={(event) => {
          event.preventDefault()
          setCurrentPaymentStep(PaymentSteps.FILL_LICENSE_PLATE)
        }}
        bold
        href="#"
        showArrowBackward
      >
        <FormattedMessage id="page.webPayment.stepFinish.button.tryAgain" />
      </MoovyLink.Link>
    </>
  )
}

export default Failure
